import { createMaterial, type MfgMaterial } from "@/lib/manufacturingClient";
import type { PoDraftLine } from "@/components/manufacturing/purchaseOrderDraftState";

export async function resolvePoDraftLineMaterial(
  line: PoDraftLine,
  opts: {
    materials: MfgMaterial[];
    plantId: string;
    onMaterialCreated: () => void;
  }
): Promise<{ ok: true; line: PoDraftLine } | { ok: false; error: string } | { ok: true; line: null }> {
  if (line.material_id) return { ok: true, line };
  const name = line.material_name.trim();
  if (!name) return { ok: true, line: null };
  const existing = opts.materials.find(
    (m) =>
      m.name.trim().toLowerCase() === name.toLowerCase() &&
      (!opts.plantId || m.plant_id === opts.plantId)
  );
  if (existing) {
    return { ok: true, line: { ...line, material_id: existing.id, material_name: existing.name } };
  }
  const created = await createMaterial({
    name,
    unit: "each",
    category: "general",
    plant_id: opts.plantId || undefined,
  });
  if (!created.ok) {
    const body = created.body as { material?: MfgMaterial } | undefined;
    if (created.status === 409 && body?.material?.id) {
      return {
        ok: true,
        line: {
          ...line,
          material_id: body.material.id,
          material_name: body.material.name || name,
        },
      };
    }
    return { ok: false, error: created.error };
  }
  opts.onMaterialCreated();
  return {
    ok: true,
    line: {
      ...line,
      material_id: created.data.material.id,
      material_name: created.data.material.name || name,
    },
  };
}
